import React from 'react';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import HomePage from "./pages/HomePage/HomePage";
import PersonaExperienceQuestionary from "./pages/PersonaExperienceQuestionary/PersonaExperienceQuestionary";

function App() {
  return (
      <div className="App">
          <Router>
              <Routes>
                  <Route exact path="/" element={<HomePage/>}/>
                  <Route path="/questionary" element={<PersonaExperienceQuestionary/>}/>
              </Routes>
          </Router>
      </div>
  );
}

export default App;
